import React from 'react'

import { useTranslation } from '@/features/locale/LocaleProvider'
import { LiquidityMobileTokenPickerSheet } from '@/mobile/token-picker/LiquidityMobileTokenPickerSheet'
import type { ImportPoolControllerResult } from '@/features/liquidity/useImportPoolController'
import { ImportPoolField } from '@/features/liquidity/useImportPoolController'
import { useAppWeb3 } from '@/hooks'
import { ChainId } from '@/sdk'
import type { WidgetRouteIntent } from '@/widgets/navigation/widgetRouteIntent'

import { LiquidityNutrimaticMobileImportFormView } from '../mobile/LiquidityNutrimaticMobileImportView'

/** Panel derecho de la tableta para importar pool. */
export function LiquidityNutrimaticImportPerformStack({
  controller,
  resolveRoute,
}: {
  controller: ImportPoolControllerResult
  resolveRoute: (intent: WidgetRouteIntent) => string
}) {
  const { chainId } = useAppWeb3()
  const t = useTranslation()
  const {
    activeField,
    currency0,
    currency1,
    handleCurrencySelect,
    handleSearchDismiss,
    showSearch,
  } = controller

  return (
    <>
      <div className="nm-tablet-trade__stage-stack" data-nutrimatic-mobile-simple>
        <div className="nm-mobile-simple__stage nm-mobile-simple__convert-layer flex min-h-0 flex-col overflow-hidden">
          <LiquidityNutrimaticMobileImportFormView
            controller={controller}
            resolveRoute={resolveRoute}
            variant="desktop-tablet"
          />
        </div>
      </div>

      <LiquidityMobileTokenPickerSheet
        open={showSearch}
        onClose={handleSearchDismiss}
        placement="embedded"
        chainId={chainId ?? ChainId.INFINITE_CREATIVE}
        title={activeField === ImportPoolField.TOKEN0 ? t.common.selectToken1 : t.common.selectToken2}
        excludeCurrency={(activeField === ImportPoolField.TOKEN0 ? currency1 : currency0) ?? undefined}
        onSelect={handleCurrencySelect}
      />
    </>
  )
}
